/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagburst2Inputs */

const en_signupsflagburst2 = /** @type {(inputs: Signupsflagburst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burst signup`)
};

const de_signupsflagburst2 = /** @type {(inputs: Signupsflagburst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoß-Registrierung`)
};

/**
* | output |
* | --- |
* | "Burst signup" |
*
* @param {Signupsflagburst2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagburst2 = /** @type {((inputs?: Signupsflagburst2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagburst2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagburst2(inputs)
	return de_signupsflagburst2(inputs)
});
export { signupsflagburst2 as "signupsFlagBurst" }